import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConsts } from './AppConsts';
import { environment } from '@src/environments/environment';

@Injectable()
export class AppConfigService {

  public version: string;
  public apiEndpointSomeData: string;

  constructor(private http: HttpClient) {}

  load(): Promise<any>  {

      const promise = this.http.get(`/assets/${environment.appConfig}`)
        .toPromise()
        .then(data => {
            Object.assign(this, data);
          return data;
        });
      return promise;
  }
}
